import { type PropsWithChildren, type ComponentProps} from 'react';
// import { classes } from '@/util/component-utils';
import styles from './Button.module.css';

export interface ButtonProps extends PropsWithChildren, ComponentProps<"button"> {
    appearance?: "primary" | "secondary" | "danger" | "dark" | "darkest" | "light" | "link";
}

export default function(props: ButtonProps) {
    const { className, appearance, ...buttonProps} = props;
    let appearanceStyle = styles.primary;
    if (props.appearance && props.appearance !== "primary") {
        if (props.appearance === "secondary") {
            appearanceStyle = styles.secondary;
        } else if (props.appearance === "danger") {
            appearanceStyle = styles.danger;
        } else if (props.appearance === "link") {
            appearanceStyle = styles.link;
        } else if (props.appearance === "dark") {
            appearanceStyle = styles.dark;
        } else if (props.appearance === "darkest") {
            appearanceStyle = styles.darkest;
        } else if (props.appearance === "light") {
            appearanceStyle = styles.light;
        }
    }
    return (
        <button className={[styles.button, appearanceStyle, className].join(' ')} {...buttonProps}>
                {props.children}
        </button>
    )
}